import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { JobItemsDto } from './job-items-job-id.dto';


export class JobItemsJobIdResponseModel extends GlobalResponseObject {
    data?: JobItemsDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: JobItemsDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

